import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { projectsKeys } from './projects.key';
import { toast } from '../../../components/Toast';

export function useDeleteProject() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async (projectId: string) => {
    const api = await getApi();
    const res = await api.projectsDeleteProject(projectId);
    return res.data;
  };

  const onSuccess = () => {
    toast.success('Projektet har raderats');
    queryClient.invalidateQueries({ queryKey: projectsKeys.all });
  };

  const onError = () => {
    toast.error('Något gick fel');
  };

  const mutation = useMutation({
    mutationFn,
    onSuccess,
    onError,
  });

  return mutation;
}
